import { Button } from '@material-ui/core';
import { Dialog } from '@progress/kendo-react-dialogs';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import React from 'react';
import useStyles from '../styles/useStyles';

interface ActionConfirmationDialogComponentProps {
    dialogActive: boolean;
    setDialogActive: React.Dispatch<React.SetStateAction<boolean>>;
    handleOnOk: Function;
    title?: string;
    text?: any;
}
const ActionConfirmationDialogComponent: React.FC<ActionConfirmationDialogComponentProps> = ({
    dialogActive,
    setDialogActive,
    handleOnOk,
    title = null,
    text = null,
}) => {
    const classesDialog = useStyles();
    title = title ?? 'Please confirm';
    text = text ?? '';
    return (
        <div>
            {dialogActive && (
                <Dialog title={title} className={classesDialog.dialog} onClose={() => setDialogActive(!dialogActive)}>
                    <ErrorOutlineIcon
                        color="error"
                        style={{ width: 60, height: 60, margin: 'auto', display: 'flex' }}
                    />
                    <div
                        style={{
                            margin: '25px',
                            textAlign: 'center',
                        }}
                        dangerouslySetInnerHTML={{
                            __html: text,
                        }}
                    ></div>
                    <div className={classesDialog.confirmationDialog}>
                        <Button
                            variant="contained"
                            color="primary"
                            style={{ marginRight: '1.5%' }}
                            onClick={() => {
                                handleOnOk();
                                setDialogActive(!dialogActive);
                            }}
                        >
                            JA
                        </Button>
                        <Button
                            variant="contained"
                            color="secondary"
                            style={{ marginLeft: '1.5%' }}
                            onClick={() => setDialogActive(!dialogActive)}
                        >
                            NEE
                        </Button>
                    </div>
                </Dialog>
            )}
        </div>
    );
};

export default ActionConfirmationDialogComponent;
